import styles from "../../styles/addInvoice.module.css";
import { useEsCliente } from "../../../../../shared/hooks/useTenantTipo";
import { useLang } from "../../../../../shared/i18n/useLang";

export default function FilialDetailsHeader() {
  const esCliente = useEsCliente();
  const L = useLang();
  return (
    <div className={styles["filial-details-header"]}>
      <h1>
        <i className={`fa-solid fa-house ${styles["icon-filial-details"]}`}></i>
        {esCliente ? L("Información del Cliente", "Client Information") : L("Información de la Filial", "Unit Information")}
      </h1>
    </div>
  );
}
